import { createFileRoute } from '@tanstack/react-router';
import { PERMISSION_REFUELING } from '../../Services/PermissionsService';
import { requirePermission } from '../../router/RouteGuardsService';
import Refuelings from '../../components/Refuelings';

export const Route = createFileRoute('/_authenticated/refuelings/')({
  beforeLoad: async ({ context }) => {
    await requirePermission(PERMISSION_REFUELING, ['read'], '/unauthorized', context);

    return {
      ...context,
      documentTitle: {
        main: 'tab.refueling',
        suffix: 'menu.refuelingsOverview',
      },
    };
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: RefuelingsRoute,
});

function RefuelingsRoute() {
  return <Refuelings />;
}
